import React from 'react';
import { CodeInput } from './CodeInput';
import { CodeInputFormFieldProps } from './types';

export const CodeInputFormField = React.forwardRef<
  HTMLDivElement,
  CodeInputFormFieldProps
>(
  ({ onChange, error, onCodeFilled, mask }, ref): React.ReactElement => (
    <div ref={ref} className="odin-flex odin-flex-col odin-gap-6">
      <CodeInput
        onChange={onChange}
        onCodeFilled={onCodeFilled ?? ((): void => undefined)}
        mask={mask}
      />
      {error ? <p className="odin-text-sm odin-text-red-600">{error}</p> : null}
    </div>
  ),
);
CodeInputFormField.displayName = 'CodeInputFormField';
